<template>
  <component
    :is="rootTag"
    :class="chipClass"
    :type="rootTag === 'button' ? 'button' : null"
    @click="$emit('click')">
    <slot>{{ label }}</slot>
    <button
      v-if="closable"
      type="button"
      class="text-sm leading-none font-semibold"
      @click.stop="$emit('remove')">
      <slot name="close">×</slot>
    </button>
  </component>
</template>

<script>
export default {
  name: 'UiChip',
  props: {
    label: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'filter'
    },
    clickable: {
      type: Boolean,
      default: true
    },
    closable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootTag() {
      return this.clickable ? 'button' : 'span';
    },
    chipClass() {
      const variants = {
        filter: 'flex items-center gap-2 bg-primary-container/10 border border-primary/20 px-4 py-2 rounded-full text-primary font-medium text-sm',
        compact: 'inline-flex items-center rounded-full bg-blue-50 text-blue-600 px-3 py-1 text-[10px] font-bold uppercase tracking-widest',
        subtle: 'inline-flex items-center rounded-full bg-slate-100 text-slate-700 px-3 py-1 text-xs font-semibold'
      };
      return variants[this.variant] || variants.filter;
    }
  }
}
</script>
